import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "@/components/ui/sonner";
import { AppShell } from "@/components/AppShell";
import { AuthProvider } from "@/lib/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { FloatingChatWidget } from "@/components/MarketingAIChat";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";

// Pages
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import MagicLoginPage from "@/pages/MagicLoginPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminClientsPage from "@/pages/AdminClientsPage";
import AdminCampaignsPage from "@/pages/AdminCampaignsPage";
import AdminProjectsPage from "@/pages/AdminProjectsPage";
import AdminCreativesPage from "@/pages/AdminCreativesPage";
import AdminFinancePage from "@/pages/AdminFinancePage";
import AdminAIToolsPage from "@/pages/AdminAIToolsPage";
import AdminAIChatPage from "@/pages/AdminAIChatPage";
import AdminTasksPage from "@/pages/AdminTasksPage";
import AdminSettingsPage from "@/pages/AdminSettingsPage";
import ClientReportsPage from "@/pages/ClientReportsPage";
import KompetenzHubPage from "@/pages/KompetenzHubPage";
import ClientAuditPage from "@/pages/ClientAuditPage";
import CorporateDevelopmentPage from "@/pages/CorporateDevelopmentPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import AGBPage from "@/pages/AGBPage";
import BrandAssetsPage from "@/pages/BrandAssetsPage";
import AboutPage from "@/pages/AboutPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import PayPerInstallPage from "@/pages/grounding/PayPerInstallPage";
import KIAppMarketingPage from "@/pages/grounding/KIAppMarketingPage";
import AppMarketingKostenPage from "@/pages/grounding/AppMarketingKostenPage";
import CPICPAPPIVergleichPage from "@/pages/grounding/CPICPAPPIVergleichPage";
import AppMarketingFintechPage from "@/pages/grounding/AppMarketingFintechPage";
import ROIRechnerPage from "@/pages/ROIRechnerPage";
import AdminLeadsPage from "@/pages/AdminLeadsPage";
import AdminSeoPage from "@/pages/AdminSeoPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <AuthProvider>
          <BrowserRouter>
            <Routes>
            {/* Public */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/magic-login" element={<MagicLoginPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/agb" element={<AGBPage />} />
            <Route path="/brand" element={<BrandAssetsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />

            {/* Client Dashboard */}
            <Route element={
              <ProtectedRoute roles={["client", "admin", "team"]}>
                <AppShell mode="client" />
              </ProtectedRoute>
            }>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/dashboard/campaigns" element={<DashboardPage />} />
              <Route path="/dashboard/reports" element={<ClientReportsPage />} />
            </Route>

            {/* Admin */}
            <Route element={
              <ProtectedRoute roles={["admin", "team"]}>
                <AppShell mode="admin" />
              </ProtectedRoute>
            }>
              <Route path="/admin" element={<AdminDashboardPage />} />
              <Route path="/admin/clients" element={<AdminClientsPage />} />
              <Route path="/admin/leads" element={<AdminLeadsPage />} />
              <Route path="/admin/seo" element={<AdminSeoPage />} />
              <Route path="/admin/campaigns" element={<AdminCampaignsPage />} />
              <Route path="/admin/projects" element={<AdminProjectsPage />} />
              <Route path="/admin/creatives" element={<AdminCreativesPage />} />
              <Route path="/admin/finance" element={<AdminFinancePage />} />
              <Route path="/admin/ai-tools" element={<AdminAIToolsPage />} />
              <Route path="/admin/ai-chat" element={<AdminAIChatPage />} />
              <Route path="/admin/tasks" element={<AdminTasksPage />} />
              <Route path="/admin/settings" element={<AdminSettingsPage />} />
              <Route path="/admin/kompetenz" element={<KompetenzHubPage />} />
              <Route path="/admin/audit" element={<ClientAuditPage />} />
              <Route path="/admin/corporate" element={<CorporateDevelopmentPage />} />
            </Route>

            {/* Grounding Pages - GEO Optimized */}
            <Route path="/was-ist-pay-per-install" element={<PayPerInstallPage />} />
            <Route path="/ki-app-marketing" element={<KIAppMarketingPage />} />
            <Route path="/app-marketing-kosten-2026" element={<AppMarketingKostenPage />} />
            <Route path="/cpi-cpa-ppi-vergleich" element={<CPICPAPPIVergleichPage />} />
            <Route path="/app-marketing-fintech" element={<AppMarketingFintechPage />} />
            <Route path="/roi-rechner" element={<ROIRechnerPage />} />
          </Routes>
          <FloatingChatWidget />
          <PWAInstallPrompt />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
    </HelmetProvider>
  );
}

export default App;
